export default __webpack_public_path__ + "static/media/jeff-card.ffe21573.svg";